import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import axios from 'axios';
import RefreshToken from '../../../partials/RefreshToken';
import Grid from '@material-ui/core/Grid';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import { AuthContext } from '../../../../@jumbo/components/context/AuthContext';
import TierAddEdit from './TierAddEdit';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import ButtonGroup from '@material-ui/core/ButtonGroup';
import { Box } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 450,
  },
  dialogStyle: {
    width: '600px',
  },
  container: {
    maxHeight: 'calc(100vh - 230px)',
    overflow: 'auto',
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  dialogButtonSection: {
    padding: '8px 20px',
    justifyContent: 'space-between',
  },
  floatRight: {
    position: 'absolute',
    top: 3,
    right: 3,
  },

  detailButton: {
    color: '#C3C8C8',
    // margin: '0 5px',
    // border: '1px solid #C3C8C8',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#F1F1F1' },
  },

  editButton: {
    color: '#00C4B4',
    // margin: '0 5px',
    // border: '1px solid #66BD4E',
    minWidth: '50px',
    '&:hover, &.Mui-focusVisible': { backgroundColor: '#00C4B410' },
  },

  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tableHeadStyle: {
    '& th': {
      fontWeight: 600,
      fontSize: '1rem',
      backgroundColor: '#000132',
      color: 'white',
    },
  },
  tableBodyStyle: {
    '& td': {
      padding: '8px 16px',
    },
  },
  cellWidth: {
    width: '230px',
  },
  // tableRowStyle: {
  //   "&:hover": {
  //     backgroundColor: "#EEF3FC !important",

  //     transform: 'scale(1.1)',
  //   }
  // },
  titleStyle: {
    marginBottom: '1rem',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  alignCenter: {
    textAlign: 'center',
  },

  groupButtonStyle: {
    '& .MuiButton-root': {
      padding: '5px 20px',
      border: '1px solid #000132',
    },
    '& .MuiButton-root:first-child': {
      borderRadius: '25px 0 0px 25px',
      // padding: '10px 30px',
    },
    '& .MuiButton-root:last-child': {
      borderRadius: '0 25px 25px 0',
      // padding: '10px 30px',
    },
  },
  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));

const TierList = () => {
  const [open, setOpen] = React.useState(false);

  const classes = useStyles();
  const { glob_pay_admin_auth, logout, login } = useContext(AuthContext);
  const [list, setList] = useState([]);
  const [detailViewItem, setDetailViewItem] = useState({});
  const [openDetailView, setOpenDetailView] = useState(false);
  const [editObj, setEditObj] = useState({});
  const [editIndexNo, setEditIndexNo] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('There is no data');
  const [addDialog, setAddDialog] = useState(false);

  const openAddDialog = () => {
    setAddDialog(true);
  };
  const closeAddDialog = (event, reason) => {
    if (reason && reason == 'backdropClick') return;

    console.log('closeAddDialog');
    setAddDialog(false);
  };

  const handleClickAway = () => {
    console.log('handleClickAway');
  };

  // ==================Delete Dialogue start==============================
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const handleDeleteDialogClickOpen = () => {
    setDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialog(false);
  };
  // ==================Delete Dialogue End==============================

  const handleClickOpenDetailView = () => {
    setOpenDetailView(true);
  };

  const handleCloseDetailView = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setOpenDetailView(false);
  };

  const handleClickView = item => {
    console.log('my item', item.requirements[0]);
    setDetailViewItem(item);
    handleClickOpenDetailView();
  };

  const getList = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .get('/api/v1/private/tier', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(function(response) {
        setList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        setMessage(error.response.data.error);
      });
    setLoading(false);
  };

  const getById = async () => {
    openAddDialog();
  };
  const handleDelete = async () => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    await axios
      .delete(`/api/v1/private/tier/${deleteId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(function(response) {
        console.log('response', response);
        let newList = list.filter(res => res.id !== deleteId);
        console.log('newList', newList);
        setList(newList);
        setDeleteDialog(false);
      })
      .catch(function(error) {
        // handle error
        console.log('error', error);
      });
    setLoading(false);
  };
  const pageLoading = () => {
    let content = [];

    for (let i = 0; i < 5; i++) {
      content.push(
        <TableRow key={i}>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
          <TableCell>
            <Skeleton />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle}>
        <Grid item md={8}>
          <Typography variant="h2">TIER LIST</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          {/* <IconButton  onClick={openAddDialog} style={{backgroundColor:'#000132'}}>
            <AddIcon fontSize="inherit" style={{color:'white'}}/>
          </IconButton> */}

          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item md={12}>
          <TableContainer component={Paper} className={classes.container}>
            <Table stickyHeader aria-label="simple table">
              <TableHead className={classes.tableHeadStyle}>
                <TableRow>
                  <TableCell>Title</TableCell>
                  {/* <TableCell align="left">Subtitle</TableCell> */}
                  <TableCell align="left">Type Of Account</TableCell>

                  <TableCell align="center">Logo</TableCell>
                  <TableCell align="center">Limit</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center" className={classes.cellWidth}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBodyStyle}>
                {list.length > 0
                  ? list.map((row, i) => (
                      <TableRow key={i} hover className={classes.tableRowStyle}>
                        <TableCell scope="row">{row.title}</TableCell>
                        {/* <TableCell align="left">{row.subTitle}</TableCell> */}
                        <TableCell align="left">{row.typeOfAccount}</TableCell>

                        <TableCell align="center">
                          <img src={row.logo} alt="" height="30px" />
                        </TableCell>
                        <TableCell align="center">
                          {row.limit && row.limit.map((item, index) => <Box key={index}>{item.recurrence}</Box>)}
                        </TableCell>

                        <TableCell align="center">
                          <img src={row.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                        </TableCell>

                        <TableCell align="center">
                          <IconButton className={classes.detailButton} onClick={() => handleClickView(row)}>
                            <VisibilityIcon />
                          </IconButton>
                          <IconButton
                            className={classes.editButton}
                            onClick={() => {
                              setEditIndexNo(i);
                              getById();
                              // openAddDialog();
                              setEditObj(row);
                            }}>
                            <EditIcon />
                          </IconButton>
                          <IconButton
                            color="secondary"
                            onClick={() => {
                              handleDeleteDialogClickOpen();
                              setDeleteId(row.id);
                            }}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  : null}
                {!loading && list.length < 1 ? (
                  <TableRow>
                    <TableCell colSpan="7" style={{ textAlign: 'center' }}>
                      {message}
                    </TableCell>
                  </TableRow>
                ) : null}
                {loading && pageLoading()}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {/* <Grid item md={4}>
          <Paper className={classes.paper}>
            <CountryAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
            />
          </Paper>
        </Grid> */}
      </Grid>

      <div>
        <Dialog
          open={openDetailView}
          onClose={handleCloseDetailView}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent>
            {detailViewItem ? (
              <TableContainer style={{ marginBottom: '40px' }}>
                <div className={classes.titleDiv}>
                  <div className={classes.iconDiv}>
                    <IconButton
                      style={{ background: 'gainsboro' }}
                      aria-label="close"
                      color="inherit"
                      size="small"
                      onClick={handleCloseDetailView}>
                      <Clear fontSize="inherit" />
                    </IconButton>
                  </div>

                  <Typography variant="h1" className={` ${classes.alignCenter}`}>
                    Tier Details
                  </Typography>
                </div>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    {/* <TableRow>
                        <TableCell colSpan="2" scope="row">

                        </TableCell>
                      </TableRow> */}
                    <TableRow>
                      <TableCell colSpan="2" scope="row" style={{ paddingTop: '0px' }}>
                        <img
                          src={detailViewItem.logo ? detailViewItem.logo : ''}
                          alt=""
                          height="80px"
                          className={classes.imgStyle}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Title</TableCell>
                      <TableCell align="left">{detailViewItem.title}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Sub Title</TableCell>
                      <TableCell align="left">{detailViewItem.subTitle}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Type of Account</TableCell>
                      <TableCell align="left">{detailViewItem.typeOfAccount}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Requirement</TableCell>
                      <TableCell align="left">
                        {detailViewItem.requirements &&
                          detailViewItem.requirements.map(e => (
                            <Box>
                              <ul>
                                <li>{e.title}</li>
                              </ul>
                            </Box>
                          ))}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell scope="row">Limits</TableCell>
                      <TableCell align="left">
                        {detailViewItem.limit &&
                          detailViewItem.limit.map((item, index) => (
                            <Box
                              key={index}
                              style={{
                                paddingBottom: '5px',
                                borderBottom: '1px solid #ddd',
                                display: 'block',
                              }}>
                              Limit Type: {item.recurrence}
                              <br />
                              Max Number Of Transaction : {item.maxNumberOfTransaction}
                              <br />
                              Max Total Amount Of Transaction: {item.maxTotalAmountOfTransaction}
                            </Box>
                          ))}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell scope="row">Status</TableCell>
                      <TableCell align="left">
                        <img src={detailViewItem.status ? '/images/ok6.svg' : '/images/cross6.svg'} alt="" height="20px" />
                      </TableCell>
                    </TableRow>

                    {/* <br/>
                      <br/> */}
                    {/* <TableRow>
                        <TableCell colSpan={2} scope="row">
                          <Button
                          fullWidth
                            variant="contained"
                            className={classes.buttonStyle}
                            // color="primary"
                            onClick={handleCloseDetailView}>
                            <Clear /> Close
                          </Button>
                        </TableCell>
                      </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </DialogContent>
        </Dialog>
      </div>
      {/* ==================Add Dialog start============================== */}

      <div>
        <Dialog
          open={addDialog}
          onClose={closeAddDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogContent className={classes.dialogStyle}>
            <TierAddEdit
              list={list}
              setList={setList}
              editObj={editObj}
              setEditObj={setEditObj}
              editIndexNo={editIndexNo}
              refresh={refresh}
              setRefresh={setRefresh}
              closeAddDialog={closeAddDialog}
              addDialog={addDialog}
            />
          </DialogContent>
        </Dialog>
      </div>

      {/* ==================Add Dialog End============================== */}
      {/* ==================Delete Dialog start============================== */}
      <div>
        <Dialog
          open={deleteDialog}
          onClose={handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              minWidth: '400px',
              boxShadow: 'none',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingBottom: '20px',
            },
          }}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography variant="h3">Are you sure to delete?</Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteDialogClose} variant="outlined">
              Cancel
            </Button>
            <Button color="secondary" onClick={handleDelete} autoFocus variant="contained">
              Delete
            </Button>
            <span>{loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null} </span>
          </DialogActions>
        </Dialog>
      </div>
      {/* ==================Delete Dialogue End============================== */}
    </React.Fragment>
  );
};

export default TierList;
